import React from 'react'

export function VaultTopbar({ onNewEval, onExport, onLogoClick, tokenCounter }) {
  return (
    <div className="ark-topbar">
      <div className="ark-topbar-left">
        <button className="ark-logo-btn active" onClick={onLogoClick}>
          ark
        </button>
      </div>

      <div className="ark-topbar-center">
        {tokenCounter}
      </div>

      <div className="ark-topbar-right">
        <button className="ark-nav-btn" onClick={onNewEval}>
          + new evaluation
        </button>
        {onExport && (
          <button className="ark-nav-btn" onClick={onExport}>
            export .md
          </button>
        )}
      </div>
    </div>
  )
}
